/** 工程工作清单的显示规则。
 * 退回设计部期间项目不属于工程部在建列表；设计部重新移交、工程侧恢复开工后再显示。
 * 其余暂停（审批流暂停 pauseSource=approval 等）同样在暂停期间隐藏，复工后自动出现。
 * 只筛选展示数据，不从全局项目库删除，财务、设计补办和历史详情仍可访问。
 * 不根据 pauseLog / returnedAt 等历史痕迹隐藏，避免已恢复项目永久消失。
 */

/** 是否处于「已退回设计部 · 工程侧暂停中」状态（项目在工程清单中隐藏，等待设计部重新移交）。
 * 两种形态都要认：
 *   ① 标准退回流程（POST /kickoff/{pid}/return-design）写 kickoff.status=returned + paused；
 *   ② 管理员人工退回（处理反馈等场景）可能不建 kickoff，只写 paused + pauseSource=eng_return_design
 *      （实测 3170 Del Vina 即此形态）。
 * 设计部重新移交时 assign_on_handoff 会清掉 paused / pauseSource / 重写 kickoff，
 * 因此只要任一字段仍处于退回态即视为退回中，无需额外时间窗判断。
 */
export function isReturnedToDesign(project) {
  if (!project) return false;
  return project.kickoff?.status === "returned"
    || (project.paused === true && project.pauseSource === "eng_return_design");
}

export function isEngineeringProjectVisible(project) {
  return !isReturnedToDesign(project) && !project?.paused;
}
